import React from 'react'
import Modal from '../Modal'
import "./styles.scss"

const component = (props) =>
  <Modal id="accessibilityOverlay" isOpened={props.isOpened} onClose={props.onClose} persistent={false}>
    <h1 className="h2">ACCESSIBILITY</h1>

    <p>If you are vision-impaired or have some other impairment covered by the Americans with Disabilities Act or a similar law, and you wish to discuss potential accommodations related to using this website, please contact accessibility@twotreesny.com.</p>

  </Modal>

component.displayName = 'AccessibilityModal';
export default component;


// WEBPACK FOOTER //
// ./client/components/AccessibilityModal/index.js